import baseAPI from '@/http'

const router = 'api/calendario/evento'

export const eventAPI = {
  create: (meeting) => baseAPI.post(router, meeting),
  update: (meeting) => baseAPI.put(router, meeting),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getByFilter: (filter) => baseAPI.post(`${router}/get-by-filtro`, filter)
}
